
export const STORE_BROKER_FIELD_DETAILS = `STORE_BROKER_FIELD_DETAILS`

export const storeBrokerFieldDetails = (payload:any): any => {
	return {
		type: STORE_BROKER_FIELD_DETAILS,
		payload
	}
}